import { GREY_DROPDOWN_CARET } from '../../assets/hostedassets';
import { StatusDropdownOption } from '../../common/_custom/StatusDropdown/StatusDropdown';
import { INVESTOR_ROUTES, LENDER_ROUTES } from './routesConst';

export type uiStyleType = {
    buttons?: {
        primary?: {
            textColour?: string;
            backgroundColour?: string;
        };
        secondary?: {
            textColour?: string;
            borderColour?: string;
            backgroundColour?: string;
        };
        tertiary?: {
            textColour?: string;
        };
    };
    tabs?: {
        active?: {
            textColour?: string;
            backgroundColour?: string;
        };
        inactive?: {
            textColour?: string;
            backgroundColour?: string;
        };
    };
    backgrounds?: {
        primary?: {
            backgroundColour?: string;
        };
        secondary?: {
            backgroundColour?: string;
        };
    };
    texts?: {
        primary?: {
            textColour?: string;
        };
    };
    borders?: {
        primary?: {
            borderColour?: string;
        };
    };
};

export enum ROOT_TYPE {
    BORROWER = 'borrower',
    INVESTOR = 'investor',
    LENDER = 'lender',
}

export const getRouteType = (currentPath: string): ROOT_TYPE.BORROWER | ROOT_TYPE.LENDER | ROOT_TYPE.INVESTOR => {
    if (Object.values(INVESTOR_ROUTES).some((route) => currentPath.startsWith(route))) {
        return ROOT_TYPE.INVESTOR;
    }
    if (Object.values(LENDER_ROUTES).some((route) => currentPath.startsWith(route))) {
        return ROOT_TYPE.LENDER;
    }
    return ROOT_TYPE.BORROWER;
};

export const defaultUiStyle: uiStyleType = {
    buttons: {
        primary: {
            textColour: '#FFFFFF',
            backgroundColour: '#6021b3',
        },
        secondary: {
            textColour: '#6021b3',
            borderColour: '#c7c7c7',
            backgroundColour: '#FFFFFF',
        },
        tertiary: {
            textColour: '#6021b3',
        },
    },
    tabs: {
        active: {
            textColour: '#6021b3',
            backgroundColour: '#f9f5ff',
        },
        inactive: {
            textColour: '#AAAAAA',
            backgroundColour: '#f7f7f7',
        },
    },
    backgrounds: {
        primary: {
            backgroundColour: '#6021b3',
        },
        secondary: {
            backgroundColour: '#f9f5ff',
        },
    },
    texts: {
        primary: {
            textColour: '#6021b3',
        },
    },
    borders: {
        primary: {
            borderColour: '#6021b3',
        },
    },
};

export const ONE_DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const TIME_DATE_FORMAT = 'hh:mm A, DD MMM YYYY';

export const DATE_FORMAT = 'DD MMM YYYY';

export const CREATE_DEAL = 'CREATE_DEAL';

export const RELATED_COMPANIES_NETWORK_TOOLTIP =
    'Discover how this entity is connected across the AICA ecosystem through its Customer and Vendor relationships';
export const AICA_REPORT_AVAILABLE_TOOLTIP = 'AICA Report available';

export const MULTIPLE_LOGIN_TOAST_ERROR = 'You’re already logged in from another tab. Please log in here to continue.';
export const INVALID_SESSION_ERROR_MESSAGE = 'Session Expired, Please Log-in Again';

export const TAB_TO_TASK_TRACKER_MAP: { [key: string]: string[] } = {
    overview: ['AION_FETCH_COMPANY_OVERVIEW', 'AION_INGEST_COMPANY_OVERVIEW'],
    relatedParty: [
        'AION_INGEST_RELATED_PARTIES_DATA',
        'AION_FETCH_RELATED_PARTIES_DATA',
        'AION_FETCH_SHAREHOLDING_PATTERN_DATA',
        'AION_INGEST_SHAREHOLDING_PATTERN_DATA',
    ],
    mcaFiling: [
        'AION_INGEST_AUDITED_FINANCIAL',
        'AION_INGEST_MCA_CHARGES_DATA',
        'AION_INGEST_SHAREHOLDERS_DATA',
        'AION_INGEST_SHAREHOLDING_PATTERN_DATA',
        'AION_INGEST_FUNDING_HISTORY',
        'AION_INGEST_RELATED_PARTIES_DATA',
        'AION_GST_TRANSACTIONS_FETCH_INGEST',
        'AION_INGEST_EPF_TRANSACTIONS',
        'AION_AUDITED_FINANCIAL',
        'AION_FETCH_MCA_CHARGES_DATA',
        'AION_FETCH_SHAREHOLDERS_DATA',
        'AION_FETCH_SHAREHOLDING_PATTERN_DATA',
        'AION_FETCH_FUNDING_HISTORY',
        'AION_FETCH_RELATED_PARTIES_DATA',
    ],
    compliances: [
        'AION_GST_TRANSACTIONS_FETCH_INGEST',
        'AION_INGEST_MCA_CHARGES_DATA',
        'AION_INGEST_AUDITED_FINANCIAL',
        'AION_GST_TRANSACTIONS_FETCH_INITIATE',
    ],
    legalChecks: [
        'AION_INGEST_LITIGATION_CLASSIFICATION_DATA',
        'AION_INGEST_AML_PEP_DATA',
        'AION_FETCH_LITIGATION_CLASSIFICATION_DATA',
        'AION_FETCH_AML_PEP_DATA',
    ],
    auditedFinancials: ['AION_AUDITED_FINANCIAL_UNLOCK', 'AION_INGEST_AUDITED_FINANCIAL', 'AION_AUDITED_FINANCIAL_CHECK'],
    creditBureau: ['AION_FETCH_MCA_CHARGES_DATA'],
    // RECUR-26035: GST tab is driven by a single Karza-profile ingest task. When the
    // user refreshes from the Overview tab, modulePollingList will contain 'gst' and
    // the GST Overview sub-tab listens to that signal to auto-refetch its data.
    gst: ['AION_INGEST_GST_PROFILE'],
    managementProfile: ['AION_FETCH_DIN_DETAILS', 'AION_KARZA_DIN_DETAILS'],
};

export const CROSS_MODULE_TASK_STEPS = new Set([
    'AION_EPF_TRANSACTIONS_FETCH',
    'AION_FETCH_FORMER_ENTITY_NAME',
    'AION_FETCH_DIRECTOR_OVERVIEW',
    'AION_INGEST_DIRECTOR_OVERVIEW',
]);

export enum TabModule {
    OVERVIEW = 'overview',
    RELATED_PARTY = 'relatedParty',
    COMPLIANCES = 'compliances',
    LEGAL_CHECKS = 'legalChecks',
    AUDITED_FINANCIALS = 'auditedFinancials',
    CREDIT_BUREAU = 'creditBureau',
    REVENUE = 'revenue',
    VENDOR_EXPENSES = 'vendorExpenses',
    BANKING_AND_FINANCIALS = 'bankingAndFinancials',
    reconciliation = 'reconciliation',
    MCA_FILING = 'mcaFiling',
    DEBT_DETAILS = 'debtDetails',
    GST = 'gst',
    MANAGEMENT_PROFILE = 'managementProfile',
}

/** Tab ids sent to Polus getTabsLockStatus after Credit Bureau directors overview loads (banking, GST, reconciliation, debt). */
export const TAB_LOCK_IDS_AFTER_DIRECTORS_OVERVIEW: string[] = [
    TabModule.DEBT_DETAILS,
    TabModule.BANKING_AND_FINANCIALS,
    TabModule.REVENUE,
    TabModule.VENDOR_EXPENSES,
    TabModule.reconciliation,
];

export const BOOLEAN_CHOICE = {
    YES: 'Yes',
    NO: 'No',
};

export const VIEW_CONFIGS = {
    AICA_DEAL_NAVBAR_VIEW: 'AICA_DEAL_NAVBAR_VIEW',
    AICA_VISIBILITY: 'AICA_VISIBILITY',
    AICA_VENDOR_SOURCE_MAP: 'AICA_VENDOR_SOURCE_MAP',
    AICA_DEBT_PRODUCT: 'AICA_DEBT_PRODUCT',
    MANDATE_QUALIFICATION_RULE_CONFIG: 'MANDATE_QUALIFICATION_RULE',
};

/** domainMetadata.productName value that scopes a PNO to Recur itself (vs. a white-labelled partner). */
export const RECUR_PRODUCT_NAME = 'RECUR-AICA';

/** Handoff URL param keys used when redirecting a PARTNER session to the resolved partner platform URL (see `getPartnerPlatformUrl` in `partnerRedirect.ts`). */
export const PARTNER_REDIRECT_HANDOFF = {
    ORG_ID: 'orgId',
    USER_ID: 'userId',
    TOKEN: 'token',
    RETURN_URL: 'returnUrl',
    EMAIL: 'email',
} as const;

/** Query flag partner-platform appends when bouncing a session back to AICA (fail-open, suppresses re-redirect). */
export const PARTNER_REDIRECT_FAILED_PARAM = 'redirectFailed';

/** Vendor id in `vendorSourceMap.AUDITED_FINANCIALS` when data is from Karza (Auditor Comments pill is hidden). */
export const AUDITED_FINANCIALS_VENDOR_KARZA = 'KARZA';

/** Vendor id in `vendorSourceMap.AUDITED_FINANCIALS` when data is from Blackstone (Auditor Comments pill is shown). */
export const AUDITED_FINANCIALS_VENDOR_PROBE = 'PROBE';
export const DESIGNATION = {
    ADMIN: 'Admin',
    TEAM_MEMBER: 'Team Member',
};

export enum ApiStatus {
    IDLE = 'idle',
    PENDING = 'pending',
    SUCCESS = 'success',
    ERROR = 'error',
}

export const ALL_ACCOUNTS = 'All Accounts';
export const AGGREGATED = 'aggregated';

export const AUDITED_TYPE_CONSOLIDATED = 'Consolidated';
export const AUDITED_TYPE_STANDALONE = 'Standalone';

// Sort direction constants
export const SORT_DIRECTIONS = {
    ASC: 'ASC' as const,
    DESC: 'DESC' as const,
};

export type SortDirection = (typeof SORT_DIRECTIONS)[keyof typeof SORT_DIRECTIONS] | null;

export type SortConfig = {
    field: string;
    direction: SortDirection;
    fieldType?: string;
};
export const defaultOptionValue: StatusDropdownOption = {
    label: '',
    value: '',
    backgroundColor: '#F5F5F5',
    labelColor: '#B4B4B4',
    customCaret: GREY_DROPDOWN_CARET,
};

export const HEADERS = {
    X_REQUESTED_ORGANIZATION_ID: 'x-requested-organization-id',
};

export const TALK_TO_US_OWNERS = {
    PARTNER: { name: 'Naman Verma', phone: '8951392730' },
    LENDER: { name: 'Sudhanshu Bhasin', phone: '7506038812' },
    BORROWER: { name: 'Pragya Rathi', phone: '8951743181' },
};

export enum MANDATE_STATES {
    DRAFT = 'DRAFT',
    SHARED = 'SHARED',
    LOST = 'LOST',
}

export enum NOTIFICATION_MODAL {
    CONTACT_US = 'contactUs',
    DEFAULT = 'default',
}

export enum QUALIFICATION_STATUS {
    QUALIFIED = 'Qualified',
    UNQUALIFIED = 'Unqualified',
}

export enum DISPATCH_EVENTS {
    REQUIREMENT_UPDATED = 'requirement-updated',
    TOOLTIP_PORTAL_SHOW = 'aica:tooltip-portal-show',
    ONEPAGER_AUTOSAVE = 'onepager-autosave',
}

export enum KEYBOARD_EVENTS {
    ENTER = 'Enter',
    BACKSPACE = 'Backspace',
    ESCAPE = 'Escape',
    DELETE = 'Delete',
    SPACE = ' ',
}

export enum TALK_TO_US {
    HEADER = 'Talk to Us',
    CONTENT = 'Call your dedicated Relationship Manager',
}

export const REPORT_TAB_KEYS = {
    AICA_REPORT: 'aicaReport',
    DATA_ROOM: 'dataRoom',
    OVERVIEW: 'Overview',
} as const;

/** Alert row `source` from API (Alert Engine). */
export const ALERT_ROW_SOURCE = {
    COMPANY: 'COMPANY',
    RELATED_PARTY: 'RELATED_PARTY',
} as const;

/** `getImage` expects these values to pick the correct icon. */
export const ENTITY_VISUAL_TYPE = {
    COMPANY: 'COMPANY',
    PERSON: 'PERSON',
} as const;

export type EntityVisualType = (typeof ENTITY_VISUAL_TYPE)[keyof typeof ENTITY_VISUAL_TYPE];

/** createDirector (polus BEFE) `responseBody.outcome`. */
export enum CreateDirectorOutcome {
    CREATED = 'CREATED',
    DUPLICATE = 'DUPLICATE',
}
